export const searchTypes = {
    'en': [{
        title: 'Buy',
        heroTitle: 'Buy',
        value: 'sale'
    },
    {
        title: 'Rent',
        heroTitle: 'Rent',
        value: 'rent'
    }],
    'th': [{
        title: 'ซื้อ',
        heroTitle: 'ซื้อ',
        value: 'sale'
    },
    {
        title: 'เช่า',
        heroTitle: 'เช่า',
        value: 'rent'
    }],
    'cn': [{
        title: '买',
        heroTitle: '买',
        value: 'sale'
    },
    {
        title: '租',
        heroTitle: '租',
        value: 'rent'
    }],
    'ru': [{
        title: 'Купить',
        heroTitle: 'Купить',
        value: 'sale'
    },
    {
        title: 'Аренда',
        heroTitle: 'Аренда',
        value: 'rent'
    }],
    'de': [{
        title: 'Kaufen',
        heroTitle: 'Kaufen',
        value: 'sale'
    },
    {
        title: 'Mieten',
        heroTitle: 'Mieten',
        value: 'rent'
    }],
    'fr': [{
        title: 'Acheter',
        heroTitle: 'Acheter',
        value: 'sale'
    },
    {
        title: 'Louer',
        heroTitle: 'Louer',
        value: 'rent'
    }]
}